<script setup>
const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true
  }
})

const emit = defineEmits(['confirm', 'cancel'])

function handleConfirm () {
  emit('confirm')
}

function handleCancel () {
  emit('cancel')
}
</script>

<template>
  <div v-if="props.isOpen" id="delete-confirmation-modal" tabindex="-1" aria-hidden="true"
    class="fixed top-0 left-0 right-0 z-50 flex items-center justify-center w-full h-full bg-gray-900 bg-opacity-50">
    <div class="bg-white rounded-lg shadow p-6 w-96">
      <h3 class="text-lg font-semibold text-gray-900 mb-4">{{ $t('conversationsSidebar.confirmDeletionTitle') }}</h3>
      <p class="text-gray-600 mb-4">{{ $t('conversationsSidebar.confirmDeletionMessage') }}</p>
      <div class="flex justify-end space-x-4">
        <button @click="handleCancel"
          class="px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300">
          {{ $t('conversationsSidebar.cancelButton') }}
        </button>
        <button @click="handleConfirm" class="px-4 py-2 text-white bg-red-600 rounded-md hover:bg-red-700">
          {{ $t('conversationsSidebar.deleteButton') }}
        </button>
      </div>
    </div>
  </div>
</template>
